export default __webpack_public_path__ + "b2d4425bb6c646fe03deb9fe39b9662c.mp4";